export const brandIntro = {
  name: '17c',
  slogan: '让效率触手可及',
  founded: '2020',
  mission: '通过技术创新，为每一位用户提供高效、便捷、可靠的数字化服务体验，助力个人成长和企业发展。',
  vision: '成为全球领先的效率工具平台，让每个人都能享受科技带来的便利。',
  values: [
    {
      title: '用户至上',
      description: '始终将用户需求放在首位，用心打磨每一个功能细节。',
      icon: 'ri-heart-line',
    },
    {
      title: '创新驱动',
      description: '拥抱变化，不断探索前沿技术，推动产品持续进化。',
      icon: 'ri-lightbulb-line',
    },
    {
      title: '诚信务实',
      description: '以真诚的态度对待每一位用户和合作伙伴，脚踏实地做好每一件事。',
      icon: 'ri-hand-heart-line',
    },
    {
      title: '追求卓越',
      description: '不满足于现状，持续挑战自我，致力于提供最优的产品和服务。',
      icon: 'ri-star-line',
    },
  ],
  milestones: [
    { year: '2020', event: '17c 平台正式上线，推出核心功能模块' },
    { year: '2021', event: '用户突破10万，获得首轮融资' },
    { year: '2022', event: '推出团队协作版，支持企业级应用' },
    { year: '2023', event: '用户突破100万，推出移动端应用' },
    { year: '2024', event: '上线 AI 智能助手，开启智能化新篇章' },
    { year: '2025', event: '全球用户突破500万，服务覆盖30+国家和地区' },
    { year: '2026', event: '发布 V3.2 版本，全面升级界面和性能' },
  ],
};

export const reputationData = {
  stats: [
    { value: '500万+', label: '全球用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.8/5', label: '用户评分' },
    { value: '30+', label: '覆盖国家' },
  ],
  awards: [
    { title: '2025年度最佳效率工具', org: '数字创新联盟', year: '2025' },
    { title: '用户最喜爱平台金奖', org: '产品评测中心', year: '2025' },
    { title: '技术创新优秀奖', org: '中国互联网协会', year: '2024' },
    { title: '最佳用户体验设计', org: 'UX设计联盟', year: '2024' },
  ],
  partners: [
    '腾讯云', '阿里云', '华为云', '京东科技', '字节跳动',
    '美团', '滴滴', '小米', '百度', '网易',
  ],
};

export const contactInfo = {
  email: 'contact@17c.com',
  phone: '400-000-1700',
  address: '北京市朝阳区建国路88号SOHO现代城A座18层',
  wechat: '17c_official',
  workingHours: '周一至周五 9:00 - 18:00',
};